/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {APITypeEnum} from '../../interface/tableAPIType';
import {tableAPIMethod} from '../../utils/tableAPIMethod';

const efdbDatabaseDropdown = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: tableAPIMethod(APITypeEnum.GET_ALL),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.efdbDropDown}/${companyId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: {}
    });

    return response.data.data?.[0];
  } catch (err) {
    console.log('err:', err);
  }
};

export default efdbDatabaseDropdown;
